import {AcquirerType} from '../project/project-country/acquirer/acquirer-type';
import {PaymentServiceModel} from '../project/payment-service/payment-service.model';

export class FinancialOperationIcon {


  public static readonly FINANCIAL_OPERATION_PAYMENT_METHOD_BANK_CARD = 1;
  public static readonly FINANCIAL_OPERATION_PAYMENT_METHOD_BALANCE = 2;
  public static readonly FINANCIAL_OPERATION_PAYMENT_PAYMENT_SERVICE = 3;
  public static readonly FINANCIAL_OPERATION_PAYMENT_ACCOUNT = 4;

  public static readonly FINANCIAL_OPERATION_STATUS_CREATE = 1;
  public static readonly FINANCIAL_OPERATION_STATUS_CANCELED_BEFORE_AUTH = 2;
  public static readonly FINANCIAL_OPERATION_STATUS_DECLINED = 3;
  public static readonly FINANCIAL_OPERATION_STATUS_AUTHORIZED = 4;
  public static readonly FINANCIAL_OPERATION_STATUS_AUTHORIZATION_CANCELED = 5;
  public static readonly FINANCIAL_OPERATION_STATUS_CONFIRMED = 6;
  public static readonly FINANCIAL_OPERATION_STATUS_REFUNDED = 7;
  public static readonly FINANCIAL_OPERATION_STATUS_AUTHORIZATION_CANCEL_ERROR = 9;
  public static readonly FINANCIAL_OPERATION_STATUS_AUTHORIZATION_CONFIRM_ERROR = 10;
  public static readonly FINANCIAL_OPERATION_STATUS_TRANSFER_ERROR = 11;
  public static readonly FINANCIAL_OPERATION_STATUS_CANCELED = 12;
  public static readonly FINANCIAL_OPERATION_STATUS_CONFIRM_ERROR = 14;
  public static readonly FINANCIAL_OPERATION_STATUS_CONFIRM_PENDING = 15;

  public static readonly FINANCIAL_OPERATION_REFUND_STATUS_NOT_REFUNDED = 1;
  public static readonly FINANCIAL_OPERATION_REFUND_STATUS_PARTIALLY_REFUNDED  = 2;
  public static readonly FINANCIAL_OPERATION_REFUND_STATUS_FULLY_REFUNDED  = 3;

  public static paymentMethodIconClass(paymentMethodId: number): string {
    switch (paymentMethodId) {
      case FinancialOperationIcon.FINANCIAL_OPERATION_PAYMENT_METHOD_BANK_CARD:
        return 'bank-card_other';
      case FinancialOperationIcon.FINANCIAL_OPERATION_PAYMENT_METHOD_BALANCE:
        return 'payment_method_balance';
      case FinancialOperationIcon.FINANCIAL_OPERATION_PAYMENT_PAYMENT_SERVICE:
        return 'ic-payment-service';
      case FinancialOperationIcon.FINANCIAL_OPERATION_PAYMENT_ACCOUNT:
        return 'bank-card_account';
      default:
        return '';
    }
  }

  public static transactionStatusIconClass(statusId: number): string {
    switch (statusId) {
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_CREATE:
        return 'transaction-state-create';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_CANCELED_BEFORE_AUTH:
        return 'transaction-state-canceled-before-auth';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_CANCELED:
        return 'transaction-state-canceled';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_DECLINED:
        return 'transaction-state-declined';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_CONFIRM_PENDING:
        return 'transaction-state-pending';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_AUTHORIZATION_CANCEL_ERROR:
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_AUTHORIZATION_CONFIRM_ERROR:
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_CONFIRM_ERROR:
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_TRANSFER_ERROR:
        return 'transaction-state-error';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_AUTHORIZED:
        return 'transaction-state-authorized';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_AUTHORIZATION_CANCELED:
        return 'transaction-state-canceled';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_CONFIRMED:
        return 'transaction-state-confirmed';
      case FinancialOperationIcon.FINANCIAL_OPERATION_STATUS_REFUNDED:
        return 'operation-type-refund-active';
      default:
        return 'transaction-state-create';
    }
  }

  public static accountTypeIconClass(acquirerType: string): string {
    switch (acquirerType) {
      case AcquirerType.PAYMENT_SYSTEM_ALFABANK:
        return 'acquire_alfaBank';
      case AcquirerType.PAYMENT_SYSTEM_BE_PAID:
        return 'acquire_bePaid';
      case AcquirerType.PAYMENT_SYSTEM_CLOUDPAYMENTS:
        return 'acquire_cloudPayments';
      case AcquirerType.PAYMENT_SYSTEM_FONDY:
        return 'acquire_fondy';
      case AcquirerType.PAYMENT_SYSTEM_IPAY:
        return 'acquire_iPay';
      case AcquirerType.PAYMENT_SYSTEM_UFC:
        return 'acquire_ufcJsc';
      case AcquirerType.PAYMENT_SYSTEM_TEST:
        return 'acquire_test';
      case AcquirerType.PAYMENT_SYSTEM_PAYANYWAY:
        return 'acquire_payAnyWay';
      case AcquirerType.PAYMENT_SYSTEM_LIQPAY:
        return 'acquire_liqpay';
      case PaymentServiceModel.PAYMENT_TYPE_OPLATI:
        return 'payment-service-oplati';
      case PaymentServiceModel.PAYMENT_TYPE_IDRAM:
        return 'payment-service-idram';
      case PaymentServiceModel.PAYMENT_TYPE_PAYANYWAY_SBP:
        return 'payment-service-payanyway-sbp';
      case AcquirerType.PAYMENT_SYSTEM_TIPTOPPAY:
      case PaymentServiceModel.PAYMENT_TYPE_CLOUDPAYMENTS_SBP:
        return 'payment-service-cloudpayments-sbp';
      case AcquirerType.PAYMENT_SYSTEM_YIGIM:
        return 'payment-service-yigim';
      case AcquirerType.PAYMENT_SYSTEM_KAPITALBANK:
        return 'acquire_kapitalbank';
      default:
        return '';
    }
  }

}
